import { render, staticRenderFns } from "./ModalSummary.vue?vue&type=template&id=1ae7fc4e&"
import script from "./ModalSummary.vue?vue&type=script&lang=js&"
export * from "./ModalSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports